export const downloadTemplate = async (
  template: Blob,
  COMPANYTEMPLATE: string,
): Promise<Blob> => {
  const blob = new Blob([template as Blob], {
    type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
  })

  const url = window.URL.createObjectURL(blob)
  const a = document.createElement('a')
  document.body.appendChild(a)
  a.href = url
  a.download = `${COMPANYTEMPLATE}.xlsx`
  a.click()
  window.URL.revokeObjectURL(url)

  return template
}
